import { useContext } from 'react';

import { ToastComponent } from '../../components/ToastComponent';
import {
  PUT_RECHARGECOUNTER,
  PUT_RECHARGECOUNTER_ERROR,
  PUT_RECHARGECOUNTER_SUCCESS,
} from '../../constants/constantsRed';
import { StoreContext } from '../../context/Provider';
import useApi from '../../services/request.service';
import { getCurrentPosition, ICoordinates } from '../../utils/utils';
import { AxiosRequestConfig } from 'axios';
import { locationPermissionService } from '../../services/locationPermissionService';

export const useRechargeCourter = () => {
  const { putRechargeCounterState } = useContext(StoreContext);
  const { genericApiCallApiBilling } = useApi();

  const putRechargeCounter = async (data: any) => {
    const currentStatus = locationPermissionService.getPermissionStatus();
    if (currentStatus !== 'granted') {
      ToastComponent(
        'warning',
        'Error',
        'Por favor activa la ubicación para continuar.',
        6000
      );
      return;
    }

    let coords: ICoordinates =
      await locationPermissionService.getCurrentCoordinates();
    putRechargeCounterState.dispatch({ type: PUT_RECHARGECOUNTER });
    try {
      const result: any = await genericApiCallApiBilling(
        '/v1.0/sam-inventory/counters',
        'PUT',
        data,
        {},
        {
          appId: 'web',
          locationGPS: `${coords?.latitude}, ${coords?.longitude}`,
        }
      );
      if (result.status === 200) {
        const payload = result.data;
        putRechargeCounterState.dispatch({
          type: PUT_RECHARGECOUNTER_SUCCESS,
          payload: payload,
        });
        ToastComponent('success', '', 'Contadores agregados correctamente');
      } else {
        const message = result?.response?.data?.message;
        ToastComponent('warning', '', message);
        putRechargeCounterState.dispatch({
          type: PUT_RECHARGECOUNTER_ERROR,
          payload: result?.response?.data,
        });
      }
      return result;
    } catch (error: any) {
      ToastComponent(
        'warning',
        'Error',
        'Error al agregar contadores, intente más tarde por favor.'
      );
      putRechargeCounterState.dispatch({
        type: PUT_RECHARGECOUNTER_ERROR,
        payload: error.message,
      });
      return 'error';
    }
  };

  return { putRechargeCounter };
};
